import countOwners from './countOwners'
import { ownerCodes } from '../config/config'

const returnAnonOwners = (owners) => {
  let ownersHtml = ''

  const ownersObject = countOwners(owners.sort())
  const keys = Object.keys(ownersObject)

  keys.forEach((key) => {
    if (ownersObject[key]) {
      ownersHtml += `<li>${ownerCodes[key]}: ${ownersObject[key]}</li>`
    }
  })

  return ownersHtml
}

export default returnAnonOwners



// WEBPACK FOOTER //
// ./src/logic/returnAnonOwners.js